import React from 'react';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ButtonProps } from 'antd/lib/button';

export type EditButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const EditButton = ({
  children = 'Edit',
  onlyIcon = false,
  ...otherProps
}: EditButtonProps) => {
  return (
    <Button icon={<EditOutlined />} type="primary" {...otherProps} >
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default EditButton;
